import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { savingsComparison } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function PriceComparison() {
  const {
    brand
  } = useBrand();
  const reduceMotion = useReducedMotion();
  const rows = [...savingsComparison.rows].sort((a, b) => a.total - b.total);
  const highest = Math.max(...rows.map(row => row.total));
  const ours = rows.find(row => row.us)?.total ?? 0;
  const saving = highest - ours;
  return <section className="bg-ink text-cream" data-id="element-107" data-mp="20726jxvatraa">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-108" data-mp="20a7x7hjkt184">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-109" data-mp="1w71tagjxrm4t">
          <div data-id="element-110" data-mp="1r86wubt1pz28">
            <p className="text-[0.6875rem] uppercase tracking-label text-copper" data-id="element-111" data-mp="1r8qgpy29axiw">
              What six months costs
            </p>
            <h2 className="mt-4 max-w-md font-serif text-3xl font-bold leading-tight md:text-5xl" data-id="element-112" data-mp="3qi6tfavtdgfe">
              Your membership pays for itself in the first month.
            </h2>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-cream/70" data-id="element-113" data-mp="jv97n1c0mx4i">
              Same medication, same pharmacies, same doctor oversight. The only thing that changes is
              how much of your money stays yours.
            </p>
            <p className="rule-light mt-8 pt-6" data-id="element-114" data-mp="fugx84reqm6n">
              <span className="block text-sm text-cream/70" data-id="element-115" data-mp="fv8stfl08jwx">By month six you could keep</span>
              <span className="mt-2 block font-serif text-5xl font-bold text-copper" data-id="element-116" data-mp="13lcvnkqdcfmv">
                ${saving.toLocaleString()}
              </span>
            </p>
          </div>

          <div data-id="element-117" data-mp="ttyrv0rdwtnx">
            <ul className="flex flex-col gap-6" data-id="element-118" data-mp="tuhxpj3rfrll">
              {rows.map(row => <li key={row.name} data-id="element-119" data-mp="ysa057216w41">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-120" data-mp="yri6i1rzv8ge">
                    <span className={`text-sm ${row.us ? 'font-medium text-copper' : 'text-cream/70'}`} data-id="element-121" data-mp="1mi48pcfbhyih">
                      {row.us ? brand.name : row.name}
                    </span>
                    <span className={`font-serif text-2xl font-bold ${row.us ? 'text-copper' : 'text-cream/70'}`} data-id="element-122" data-mp="1w71fwj50ink5">
                      ${row.total.toLocaleString()}
                    </span>
                  </div>
                  <div className="mt-2 h-3 w-full overflow-hidden rounded-full bg-cream/10" data-id="element-123" data-mp="1i708sly5mjw8">
                    <motion.div initial={reduceMotion ? false : {
                  width: 0
                }} whileInView={{
                  width: `${row.total / highest * 100}%`
                }} viewport={{
                  once: true,
                  amount: 0.6
                }} transition={{
                  duration: 0.5,
                  ease: [0.23, 1, 0.32, 1]
                }} className={`h-full rounded-full ${row.us ? 'bg-copper' : 'bg-cream/25'}`} data-id="element-124" data-mp="1dgtkkn7k11ei" />
                  </div>
                </li>)}
            </ul>
            <p className="mt-8 max-w-2xl text-xs leading-relaxed text-cream/50" data-id="element-125" data-mp="365kj5i7kh1vy">
              {savingsComparison.note}
            </p>
          </div>
        </div>
      </div>
    </section>;
}